var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-viewer"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"pdf-viewer__loader"},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":60,"width":2}})],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"pdfViewer",staticClass:"pdf-viewer__content",style:({
      cursor: _vm.isDragging ? 'grabbing' : 'grab',
      scrollSnapType: _vm.isDragging ? '' : '',
    }),on:{"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp}})])
}
var staticRenderFns = []

export { render, staticRenderFns }